export class CopyToClipboard
{
    static copyToClipboard(value: string): void
    {
        navigator.clipboard.writeText(value);
    }
};